import {
  ADMIN_MARK_COMPLETED_FAIL,
  ADMIN_MARK_COMPLETED_REQUEST,
  ADMIN_MARK_COMPLETED_RESET,
  ADMIN_MARK_COMPLETED_SUCCESS,
  ADMIN_SUBMISSIONS_LIST_FAIL,
  ADMIN_SUBMISSIONS_LIST_REQUEST,
  ADMIN_SUBMISSIONS_LIST_RESET,
  ADMIN_SUBMISSIONS_LIST_SUCCESS,
  BUNDLE_PRICING_LIST_FAIL,
  BUNDLE_PRICING_LIST_RESET,
  BUNDLE_PRICING_LIST_SUCCESS,
  BUNDLE_PRICING_REQUEST,
  CERTIFICATE_CATEGORY_LIST_FAIL,
  CERTIFICATE_CATEGORY_LIST_REQUEST,
  CERTIFICATE_CATEGORY_LIST_RESET,
  CERTIFICATE_CATEGORY_LIST_SUCCESS,
  CERTIFICATE_GET_BY_SLUG_FAIL,
  CERTIFICATE_GET_BY_SLUG_REQUEST,
  CERTIFICATE_GET_BY_SLUG_RESET,
  CERTIFICATE_GET_BY_SLUG_SUCCESS,
  PROBLEM_STATEMENT_LIST_FAIL,
  PROBLEM_STATEMENT_LIST_REQUEST,
  PROBLEM_STATEMENT_LIST_RESET,
  PROBLEM_STATEMENT_LIST_SUCCESS,
  SOLO_PRICING_FAIL,
  SOLO_PRICING_REQUEST,
  SOLO_PRICING_RESET,
  SOLO_PRICING_SUCCESS,
  USER_CERTIFICATTION_REGISTRATION_CREATE_FAIL,
  USER_CERTIFICATTION_REGISTRATION_CREATE_REQUEST,
  USER_CERTIFICATTION_REGISTRATION_CREATE_RESET,
  USER_CERTIFICATTION_REGISTRATION_CREATE_SUCCESS,
  USER_CERTIFICATTION_REGISTRATION_LIST_FAIL,
  USER_CERTIFICATTION_REGISTRATION_LIST_REQUEST,
  USER_CERTIFICATTION_REGISTRATION_LIST_RESET,
  USER_CERTIFICATTION_REGISTRATION_LIST_SUCCESS,
  USER_CERTIFICATTION_REGISTRATION_SUBMIT_FAIL,
  USER_CERTIFICATTION_REGISTRATION_SUBMIT_REQUEST,
  USER_CERTIFICATTION_REGISTRATION_SUBMIT_RESET,
  USER_CERTIFICATTION_REGISTRATION_SUBMIT_SUCCESS,
  USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_FAIL,
  USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_RESET,
  USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_SAVE,
} from "../../constants/MyCertificates/CertificatesConstants";

export const CertificateCategoryListReducer = (state = {}, action) => {
  switch (action.type) {
    case CERTIFICATE_CATEGORY_LIST_REQUEST:
      return { loading: true };
    case CERTIFICATE_CATEGORY_LIST_SUCCESS:
      return { loading: false, success: true, categories: action.payload };
    case CERTIFICATE_CATEGORY_LIST_FAIL:
      return { loading: false, error: action.payload };
    case CERTIFICATE_CATEGORY_LIST_RESET:
      return {};
    default:
      return state;
  }
};

export const CertificateGetBySlugReducer = (state = {}, action) => {
  switch (action.type) {
    case CERTIFICATE_GET_BY_SLUG_REQUEST:
      return { loading: true };
    case CERTIFICATE_GET_BY_SLUG_SUCCESS:
      return { loading: false, success: true, certifications: action.payload };
    case CERTIFICATE_GET_BY_SLUG_FAIL:
      return { loading: false, error: action.payload };
    case CERTIFICATE_GET_BY_SLUG_RESET:
      return {};
    default:
      return state;
  }
};

export const ProblemStatementListReducer = (state = {}, action) => {
  switch (action.type) {
    case PROBLEM_STATEMENT_LIST_REQUEST:
      return { loading: true };
    case PROBLEM_STATEMENT_LIST_SUCCESS:
      return {
        loading: false,
        success: true,
        problemStatements: action.payload,
      };
    case PROBLEM_STATEMENT_LIST_FAIL:
      return { loading: false, error: action.payload };
    case PROBLEM_STATEMENT_LIST_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer for getting user registrations list
export const UserRegistrationListReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_CERTIFICATTION_REGISTRATION_LIST_REQUEST:
      return { loading: true };
    case USER_CERTIFICATTION_REGISTRATION_LIST_SUCCESS:
      return { loading: false, success: true, registrations: action.payload };
    case USER_CERTIFICATTION_REGISTRATION_LIST_FAIL:
      return { loading: false, error: action.payload };
    case USER_CERTIFICATTION_REGISTRATION_LIST_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer for creating/registering for certification
export const UserRegistrationCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_CERTIFICATTION_REGISTRATION_CREATE_REQUEST:
      return { loading: true };
    case USER_CERTIFICATTION_REGISTRATION_CREATE_SUCCESS:
      return { loading: false, success: true, registration: action.payload };
    case USER_CERTIFICATTION_REGISTRATION_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case USER_CERTIFICATTION_REGISTRATION_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer for submitting GitHub link
export const UserRegistrationSubmitReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_CERTIFICATTION_REGISTRATION_SUBMIT_REQUEST:
      return { loading: true };
    case USER_CERTIFICATTION_REGISTRATION_SUBMIT_SUCCESS:
      return { loading: false, success: true, submittedData: action.payload };
    case USER_CERTIFICATTION_REGISTRATION_SUBMIT_FAIL:
      return { loading: false, error: action.payload };
    case USER_CERTIFICATTION_REGISTRATION_SUBMIT_RESET:
      return {};
    default:
      return state;
  }
};

export const adminSubmissionsListReducer = (
  state = { submissions: [], page: 1, totalPages: 1 },
  action
) => {
  switch (action.type) {
    case ADMIN_SUBMISSIONS_LIST_REQUEST:
      return { ...state, loading: true };
    case ADMIN_SUBMISSIONS_LIST_SUCCESS:
      return {
        loading: false,
        success: true,
        submissions: action.payload.submissions,
        page: action.payload.page,
        limit: action.payload.limit,
        total: action.payload.total,
        totalPages: action.payload.totalPages,
        count: action.payload.count,
        message: action.payload.message,
      };
    case ADMIN_SUBMISSIONS_LIST_FAIL:
      return { loading: false, error: action.payload };
    case ADMIN_SUBMISSIONS_LIST_RESET:
      return { submissions: [], page: 1, totalPages: 1 };
    default:
      return state;
  }
};

export const adminMarkCompletedReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_MARK_COMPLETED_REQUEST:
      return { loading: true };
    case ADMIN_MARK_COMPLETED_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case ADMIN_MARK_COMPLETED_FAIL:
      return { loading: false, error: action.payload };
    case ADMIN_MARK_COMPLETED_RESET:
      return {};
    default:
      return state;
  }
};

export const userRegistrationEachCardSaveReducer = (state = {}, action) => {
  switch (action.type) {
    case USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_SAVE:
      return { loading: false, success: true, data: action.payload };
    case USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_FAIL:
      return { loading: false, error: action.payload };
    case USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_RESET:
      return {};
    default:
      return state;
  }
};

export const bundlePricingReducer = (state = {}, action) => {
  switch (action.type) {
    case BUNDLE_PRICING_REQUEST:
      return { loading: true };
    case BUNDLE_PRICING_LIST_SUCCESS:
      return {
        loading: false,
        success: true,
        bundlePricingResult: action.payload,
      };
    case BUNDLE_PRICING_LIST_FAIL:
      return { loading: false, error: action.payload };
    case BUNDLE_PRICING_LIST_RESET:
      return {};
    default:
      return state;
  }
};

export const soloPricingReducer = (state = {}, action) => {
  switch (action.type) {
    case SOLO_PRICING_REQUEST:
      return { loading: true };
    case SOLO_PRICING_SUCCESS:
      return {
        loading: false,
        success: true,
        soloPricingResult: action.payload,
      };
    case SOLO_PRICING_FAIL:
      return { loading: false, error: action.payload };
    case SOLO_PRICING_RESET:
      return {};
    default:
      return state;
  }
};
